import React from 'react';
import Page from 'src/components/Page';
import text from 'platform/constants/text.js';
import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';

function HomePage() {

    return (
    <>
        <Page header="Developer Reference">
            <p>
                Welcome to the developer reference for the {text.platformName} version 5 API.
            </p>
            <p>
                The developer reference covers three sections:
                <ul>
                    <li>The <b>Getting started</b> section allows you to become familiar with the API by develping your own implementation of an iFrame payment page in <Link end to={routes.getstarted.quickstart}>QuickStart</Link>.</li>
                    <li>The <b>API</b> section provides <Link end to={routes.api.root}>API</Link> specs and how-to-guides on develping your payment application and other features such as batch processing and card tokenisation.</li>
                    <li>The <b>Reference</b> section provides definitions for Country, Bank response and Currency codes</li>
                </ul>
            </p>
            <br />
            <br />
            <h3>Disclaimer</h3>
            <p>
                <i>Linkly reserves the right to modify its API scripts at any time. Please be aware that such changes may impact the functionality of payment pages where Subresource Integrity (SRI) has been used for script integrity checking. It is the responsibility of the merchant to ensure that their implementation remains functional and secure following any updates to the API scripts.</i>
            </p>
        </Page>
    </>);
}

export default HomePage;